export default "__VITE_ASSET__DzS$PliS__"